import { TNextStepsFields, TNextStepsFieldsCard, TNextStepsProps } from '../types/nextSteps.types';
import { StringField } from '../../../types/types';
import { ComponentParams } from '@sitecore-jss/sitecore-jss-react';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';

export class NextStepsModel {
  private readonly fields: TNextStepsFields;
  private readonly params: ComponentParams;

  constructor(props: TNextStepsProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || null;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get title(): StringField {
    return this.fields?.title || { value: '' };
  }

  get cards(): TNextStepsFieldsCard[] {
    return this.fields?.items || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
